module.exports = __webpack_public_path__ + "img/suit-11.2fb337d6.png";